export enum ConfirmationType {
  Confirm = 1,
  Cancel = 2,
  InvalidRequest = 3
}
